module.exports = __webpack_public_path__ + "img/hand_with_ticket.7eca02f7.svg";